var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 30 30",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#FD6A7E;} .st1{fill:#17B978;} .st2{fill:#8797EE;} .st3{fill:#41A6F9;} .st4{fill:#37E0FF;} .st5{fill:#2FD9B9;} .st6{fill:#F498BD;} .st7{fill:#FFDF1D;} .st8{fill:#C6C9CC;} "), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,11c1.8,0,3.3,1.3,3.5,3c0.2,1.7-1.3,3-3.4,3s-3.6-1.3-3.5-3S13.3,11,15.1,11z M19.7,9l1.9,11.1 C21.3,20,21,20,20.5,20c-1.5,0.1-2.7,1.1-2.8,2.2c0,0.3,0,0.6,0.1,0.8h-4.8c0.1-0.2,0.1-0.5,0.1-0.8c-0.2-1.1-1.4-2.1-2.9-2.2 c-0.4,0-0.8,0-1.1,0L10.5,9H8L5.4,23c-0.3,1.7,0,3,2.5,3h15.2c2.5,0,2.7-1.3,2.3-3L22,9H19.7z M26,4H4C3.4,4,3,4.4,3,5v5 c0,0.6,0.4,1,1,1h1.5l0.9-4h17.1l1.2,4H26c0.6,0,1-0.4,1-1V5C27,4.4,26.6,4,26,4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/atm.51f84f3c9c7690cf0438d5c12d65e776.svg";
export { ForwardRef as ReactComponent };